<template>
  <div class="newsdetails">
    <img src="../../assets/img/news-banner.png" width="100%" alt="">
    <h3>{{newsdetail.newsTitle}}</h3>
    <p class="time"><em>{{newsdetail.publishTime}}</em> <em>{{newsdetail.newsAuthor}}</em></p>
    <div class="tags" v-if="tagNameList.length>0">
      <span v-for="(item,index) in tagNameList " :key="index">{{item.tagName}}</span>
    </div>
    <!-- <img src="" alt=""> -->
    <p class="con" v-html="newsdetail.content">
    </p>
  </div>
</template>
<script>
import Api from '@api/news'
import fetch from '@api/system'
export default {
  name:'newsdetails',
  components:{},
  props:{},
  data(){
    return {
      newsdetail:{},
      id:'',
      mataInfo:{
        title:'',
        keywords:'',
        description:''
      },
      tagNameList:[]
    }
  },
  metaInfo () {
    return {
        title:this.mataInfo.title,
        meta: [{                 // set meta
          name: 'keyWords',
          content: this.mataInfo.keywords,
        },{                 // set meta
          name: 'description',
          content: this.mataInfo.description,
        }]
    }
  },
  created(){
    this.id = this.$route.query.id
    this.getNewsDetails()
    this.getMateInfo();
  },
  methods:{
    getNewsDetails(){
      Api.fetchDetail({newsId:this.id}).then(res=>{
        this.newsdetail = res.data.data
        this.tagNameList = res.data.data.tagNameList
      })
    },
    getMateInfo(){
      fetch.fetchParamsList().then(res=>{
        // console.log(res.data.data)
        const data = res.data.data
        this.mataInfo.title = data.name
        this.mataInfo.keywords = data.keyword
        this.mataInfo.description = data.desc
      })
    }
  }
}
</script>
<style lang="scss">
  .newsdetails{
    img{
    display: block;
    width: 100%!important;
    height: auto!important;
    }
    h3{
      font-size:34px;
      // font-weight: bold;
      text-align: center;
      color:#333;
      margin-top:20px;
    }
    .time{
      margin:10px 0;
      font-size:24px;
      color:#666;
      text-align: center;
      line-height: normal;
      em{
        padding-right:10px;
      }
    }
    .tags{
      text-align: center;
      span{
        background:#e2f2fd;
        padding:5px;
        color:#5facd8;
        border-radius:20px;
        padding:0 20px;
        margin-right:5px;
      }
    }
    .con{
      margin:30px 0 50px;
      padding:0 40px;
      font-size:28px;
      line-height:50px;
    }
  
  }
</style>